import { Container, Drawer, Grid, styled } from "@mui/material";
import { useMemo, useState } from "react";

import SearchInput from "components/SearchInput";
import TableDrawer from "./Component/TableDrawer";
import { useEffect } from "react";
import { repeat } from "utils/helpers/interval";
import useDispatch from "hooks/useDispatch";
import { getInvestmentMarketWithAccountBrokerList } from "store/slices/market/marketSlice";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { search } from "utils/helpers/search";

let getInvestmentMarketInterval;

function MarketDrawer({ open, onClose, onRowClick }) {
  const dispatch = useDispatch();

  const investmentMarketList = useSelector((state) => state.market?.investmentMarketWithAccountBrokerList?.data)
  const tradeInsertForm = useSelector((state) => state.trade?.tradeInsertForm?.data)

  const [searchParams] = useSearchParams()
  const brokerId = +searchParams.get("brokerId") || tradeInsertForm?.brokerId || 0;

  const [loading, setLoading] = useState(true)
  const [value, setValue] = useState();

  const handleSearch = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  const searchedMarketList = useMemo(() => {
    return search({
      list: investmentMarketList,
      value,
      keys: ["coinSourceName", "coinDestinationName"],
    });
  }, [investmentMarketList, value]);

  const handleGetInvestmentMarketList = async () => {
    await dispatch(getInvestmentMarketWithAccountBrokerList({ brokerId }))
    setLoading(false)
  };


  const repeatGetInvestmentMarketList = () => {
    handleGetInvestmentMarketList();

    clearInterval(getInvestmentMarketInterval);

    getInvestmentMarketInterval = repeat({
      action: () => handleGetInvestmentMarketList(),
    });

    return () => {
      clearInterval(getInvestmentMarketInterval);
    };
  };

  useEffect(() => {
    handleGetInvestmentMarketList()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!open) {
      clearInterval(getInvestmentMarketInterval);
    } else {
      repeatGetInvestmentMarketList();
    }

    return () => {
      clearInterval(getInvestmentMarketInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <DrawerStyle anchor="left" open={open} onClose={onClose}>
      <Container sx={{ mt: 2 }}>
        <Grid container>
          <SearchInput value={value} onChange={handleSearch} />

          <TableDrawer
            onRowClick={onRowClick}
            hideBorders={true}
            coinList={searchedMarketList}
            loading={loading}
          />
        </Grid>
      </Container>
    </DrawerStyle>
  );
}

const DrawerStyle = styled(Drawer)(() => ({
  width: "90%",

  ".MuiDrawer-paper": {
    width: "90%",
    maxWidth: "400px",
  },
}));

export default MarketDrawer;
